export default function StatusPill({ status, prohibited }) {
  let color = "var(--success)"; let label = status || "Active";
  if (prohibited || status === "Banned") { color = "var(--danger)"; label = "PROHIBITED"; }
  else if (status === "Restricted") { color = "var(--warning)"; }
  return (
    <span className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.14em]" data-testid="status-pill">
      <span className="status-dot" style={{ background: color }} />
      {label}
    </span>
  );
}
